import { ApiMetaData } from "@/types/types";
import  { useEffect, useState } from "react";
import SortWithdrawRequests from "./components/SortWithdrawRequests";
import InputField from "@/components/form/InputField";
import WithdrawRequestTable from "./components/WithdrawRequestTable";
import { useGetWithDrawRequestsQuery } from "@/redux/feature/balaneWithdraw/balaneWithdrawApi";
import Pagination from "@/components/ui/Pagination";
import { useGlobalContext } from "@/context/GlobalContext";

const CreatorWithdrawsPage = () => {
  const [page, setPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState<string>("all");
  const {userData} = useGlobalContext()


  const { data, isLoading, error, isFetching } = useGetWithDrawRequestsQuery([
    { name: "page", value: page },
    { name: "limit", value: 10 },
    { name: "status", value: selectedStatus },
    { name: "creator_id", value: userData?.creator_id },
  ]
,
{
  skip:! userData?.creator_id
});
  
  if (error) {
    return (
      <div className="px-4 md:px-11 mt-[25px] md:mt-7 mb-10">
        <h1 className="text-xl font-semibold">Withdraw Requests</h1>
        <div className="mt-4 text-red-500">Error loading  requests</div>
      </div>
    );
  }
  const handleFilterChange = (newFilter: string) => {
    setSelectedStatus(newFilter);
  };
  const meta = data?.data?.meta as Partial<ApiMetaData>;
  const requestsData = data?.data?.data;
  return (
    <div>
      <div className="px-4 md:px-11 mt-[25px] md:mt-7 mb-10">
        <div>
          <div className="flex justify-between items-center">
            <h1 className="text-xl font-semibold">Withdraw Requests</h1>
            <div className="flex items-center gap-x-4">
              <SortWithdrawRequests
                selectedFilter={selectedStatus}
                onFilterChange={handleFilterChange}
              />
           
            </div>
          </div>
        </div>
        <div>
          {isLoading || isFetching ? (
            <div>
              <p className="p-20 text-center">Loading</p>
            </div>
          ) : (
            <WithdrawRequestTable data={requestsData}/>
          
          )}
        </div>
        {/* Pagination */}
        <div>
          <Pagination
            setPage={setPage}
            currentPage={page}
            totalPages={meta?.totalPages as number}
          />
        </div>
      </div>
    </div>
  );
};

export default CreatorWithdrawsPage;
